import { createAppTranslator, formatCurrencyMinor, resolveLocale } from '@ai-factory/i18n';

export function formatPrice(amount: number, currency: string, locale = 'en-US'): string {
  return formatCurrencyMinor(amount, currency, resolveLocale(locale));
}

export function resolveAppAccountId(search: string, stored: string | null): string | null {
  return new URLSearchParams(search).get('app_account_id') || stored;
}

export function intervalLabel(interval: string, locale?: string): string {
  const t = createAppTranslator('billing', locale);
  if (interval === 'monthly') return t('billing.month');
  if (interval === 'yearly') return t('billing.year');
  return t('billing.one_time');
}
